define('lib/view/BookingUrlBuilder',['require','marionette'],function (require) {
	
	var Marionette = require('marionette');
	
	/**
	 * Booking URL builder based on BokingModel data
	 */
	var BookingUrlBuilder = Marionette.Object.extend({
		
		_bookingModel: null,
		_urlParams: {},
		_bookingMode: 'class',
		
		/**
		 * Set BookingModel instance
		 * 
		 * @param BookingModel model
		 */
		setBookingModel: function (model) {
			this._bookingModel = model;
		},
		
		/**
		 * Builds url based on booking model data and extra params (extParams)
		 * 
		 * @param String urlType
		 * @param Object extParam
		 * @return String
		 */
		buildUrl: function (urlType, extParams) {
			var result = 'book/';
            if (this.getBookingMode() === 'class') {
                result = 'book-class/';
            }

			switch (urlType) {
				case 'first_booking_step':
					break;
				case 'booking_step':
					result += this._buildStepUrl(extParams);
					break;
				case 'finish_step':
					result = 'client/bookings';
					if (extParams.ids) {
						result += '/ids/' + extParams.ids.join(',');
					}
					if (extParams.status) {
						result += '/status/' + extParams.status;
					}
					if (!_.isUndefined(extParams.waiting_list) || !_.isUndefined(extParams.wl) ) {
						result += '/wl/' + ((extParams.waiting_list || extParams.wl)?1:0);
					}
					break;
			}

			return result;
		},

		/**
		 * Builds booking step url based on booking model data and extra params (extParams)
		 * 
		 * @param Object extParam
		 * @return String
		 */
		_buildStepUrl: function (extParams) {
			var isGroupBookingActive = Config.getInstance().getPluginStatus('group_booking');
			var params = ['location', 'category', 'service', 'count', 'addons', 'provider', 'date', 'time', 'wl', 'r'];
			if (Config.getInstance().getTimelineType() === Config.TIMELINE_CLASSES_PLUGIN) {
                params = ['location', 'category', 'service', 'count', 'date', 'time', 'provider', 'wl', 'r'];
			}
			if (Config.getInstance().getTimelineType() === Config.TIMELINE_CLASSES) {
				params = ['location', 'category', 'service', 'count', 'provider', 'date', 'time', 'wl', 'r'];
			}

			var urlParams = _.extend({}, this._getUrlParams(), extParams);

			if(!urlParams['service'] && urlParams['count'] && !isGroupBookingActive){
				urlParams['count'] = 1;
			}
			
			var result = '';
			for (var i = 0; i < params.length; i++) {
				var param = params[i];
				if (urlParams[param]) {
					if(param === 'r'){
						urlParams[param] = Math.floor(Math.random() * 99999);
					}
					result += param + '/' + urlParams[param] + '/';
				}
			}
			
			return result;
		},
		
		/**
		 * Returns current booking data
		 * 
		 * @return Object
		 */
		_getUrlParams: function () {
			var params =  {
				'location': this._bookingModel.get('location_id'),
				'category': this._bookingModel.get('category_id'),
				'service': this._bookingModel.get('service_id'),
				'addons': this._bookingModel.get('addons') || this._bookingModel.getAddons(),
				'provider': this._bookingModel.get('provider_id'),
				'date': this._bookingModel.get('start_date'),
				'time': this._bookingModel.get('start_time'),
				'wl': this._bookingModel.get('wl'),
				'r': this._bookingModel.get('r'),
			};

			if(this._bookingModel.get('count')){
				params['count'] = this._bookingModel.get('count');
			}
			return params;
		},

        /**
		 * Set booking mode (service/class)
		 *
         * @param mode
         */
        setBookingMode: function (mode) {
			this._bookingMode = mode;
		},

        /**
		 * Return booking mode
		 *
         * @return {string}
         */
        getBookingMode: function () {
			return this._bookingMode;
		}
		
	});
	
	/**
	 * Singleton implementation
	 */
	BookingUrlBuilder._instance = null;
	
	/**
	 * Returns BookingUrlBuilder instance
	 * 
	 * @return BookingUrlBuilder
	 */
	BookingUrlBuilder.getInstance = function () {
		if (!BookingUrlBuilder._instance) {
			BookingUrlBuilder._instance = new BookingUrlBuilder();
		}
		
		return BookingUrlBuilder._instance;
	};
	
	return BookingUrlBuilder;
	
});
